import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentDriveChildren from "./routes/StudentDriveChildren";
export default store => ({
  path: "student-drive",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-student-drive" */ "./components"),
        import(
          /* webpackChunkName: "course-student-drive" */ "./modules/StudentDriveModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "studentDrive",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [StudentDriveChildren(store)],
});
